import { Button, Modal, Space } from 'antd';
import { useState } from 'react';
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer-continued';

interface ActivityLogsJsonDiffModalProps {
  newValue: string | null;
  oldValue: string | null;
}

export const ActivityLogsJsonDiffModal = ({ newValue, oldValue }: ActivityLogsJsonDiffModalProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <span className="open-citations-btn" onClick={() => setIsOpen(true)}>
        View difference
      </span>
      <Modal centered title="Difference" width={1200} open={isOpen} wrapClassName="custom-modal" closable={false}>
        <Space>
          <ReactDiffViewer
            newValue={JSON.stringify(JSON.parse(newValue ?? '{}'), null, 2)}
            oldValue={JSON.stringify(JSON.parse(oldValue ?? '{}'), null, 2)}
            splitView={true}
            compareMethod={DiffMethod.JSON}
            styles={{
              contentText: {
                whiteSpace: 'pre-wrap',
                fontFamily: 'monospace',
                lineHeight: '1.5',
              },
              line: {
                padding: '0 10px',
              },
            }}
          />
        </Space>
        <Space className="footer">
          <Button type="link" onClick={() => setIsOpen(false)}>
            Close
          </Button>
        </Space>
      </Modal>
    </>
  );
};
